<template>
  <div class="home_box flex_all">
    <div class="login_box flex">
      <div class="login_left">
        <p class="info">
          <span>ShopVidi</span> - Global Brands, Local Retailers, One
          Entrepreneur Dream!
        </p>
        <img
          class="login_img"
          src="https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-login_img.png"
          alt=""
        />
        <div class="icon_line_box">
          <div class="icon_line flex">
            <img
              class="icon_img"
              src="https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-line1.png"
              alt=""
            />
            <p class="text_p2">Access to numerous retailers across the states</p>
          </div>
          <div class="icon_line flex">
            <img
              class="icon_img"
              src="https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-line2.png"
              alt=""
            />
            <p class="text_p2">Guaranteed payments on every order</p>
          </div>
          <div class="icon_line flex">
            <img
              class="icon_img"
              src="https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-line3.png"
              alt=""
            />
            <p class="text_p2">Risk-free terms extended to retailers</p>
          </div>
          <div class="icon_line flex">
            <img
              class="icon_img"
              src="https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-line4.png"
              alt=""
            />
            <p class="text_p2">Retailer veriﬁcation, payment collection, & customer support</p>
          </div>
          <div class="icon_line flex">
            <img
              class="icon_img"
              src="https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-line5.png"
              alt=""
            />
            <p class="text_p2">Analytics, and tools to streamline your business</p>
          </div>
        </div>
      </div>
      <div class="login_right">
        <img class="shopvidi_logo" src="@/assets/img/shopvidi_logo.png" alt="">
        <el-form :model="registerForm" ref="registerForm" :rules="rules">
          <el-form-item
            prop="username"
            :rules="{
              required: true,
              validator: userNameCheck,
              trigger: ['blur','change'],
            }"
          >
            <el-input
              v-model="registerForm.firstName"
              placeholder="First Name"
              oninput="if(value){value=value.toLowerCase()}"
              onblur="if(value){value=value.trim()}"
            />
          </el-form-item>
          <el-form-item
            prop="username"
            :rules="{
              required: true,
              validator: userNameCheck2,
              trigger: ['blur','change'],
            }"
          >
            <el-input
              v-model="registerForm.lastName"
              placeholder="Last Name"
              oninput="if(value){value=value.toLowerCase()}"
              onblur="if(value){value=value.trim()}"
            />
          </el-form-item>
          <el-form-item
            prop="email"
            :rules="[
            {
              required: true,
              message: 'Please enter the email',
              trigger: ['blur','change']
            },
            { validator: checkEmail, trigger: ['blur','change'] }
          ]"
          >
            <el-input
              v-model="registerForm.email"
              placeholder="Business Email"
              oninput="if(value){value=value.toLowerCase()}"
              onblur="if(value){value=value.trim()}"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="flex cust-form-item cust-form-item2"
            prop="phone"
          >
            <el-select
              v-model="codeObject"
              filterable
              placeholder="+ Country Code"
              @change="codeChange"
            >
              <el-option
                v-for="(item, index) in options"
                :label="item.text"
                :value="item"
                :key="index"
              >
                <span style="float: left">{{ item.text }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{
                  item.value
                }}</span>
              </el-option>
            </el-select>
            <el-input
              v-model="registerForm.phone"
              placeholder="Phone"
              @input="changePhone"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="password"
            class="cust-form-item"
            :rules="{ validator: handlePasswordLevel, trigger: 'change' }"
          >
            <el-popover
              ref="popover"
              placement="top-start"
              width="200px"
              trigger="focus"
            >
              <div :style="'color:' + levelColor[levelStatus]">
                <i :class="levelClass[levelStatus]"></i>
                {{ levelNames[levelStatus] }}
              </div>
              <div style="display: flex;">
                <el-progress
                  style="width: 33%"
                  v-for="(item, id) in levelNames"
                  :key="id"
                  v-if="id > 0"
                  :percentage="
                    id > levelStatus ? 0 : id < levelStatus ? 100 : levelPercent
                  "
                  :show-text="false"
                  :color="levelColor[levelStatus]"
                ></el-progress>
              </div>
            </el-popover>
            <el-input
              v-popover:popover
              :type="passw"
              @focus="changeType"
              v-model="registerForm.password"
              autocomplete="new-password"
              placeholder="Password"
            >
              <i slot="suffix" @click="showPass">
                <img
                  v-if="passw=='password'"
                  class="reg-show-hide-icon"
                  src="@/assets/img/icon-hide.png"
                  alt="" />
                <img
                  v-else
                  class="reg-show-hide-icon"
                  src="@/assets/img/icon-show.png"
                  alt="" />
              </i>
            </el-input>
          </el-form-item>
          <div class="text_agreen_register">By clicking Login, you agree to our <a href="https://www.shopvidi.com/term-service"><span class="organ_color" >Terms of Service</span></a></div>
          <el-button
              type="primary"
              :disabled="loading"
              @click="submitForm('registerForm')"
              class="btn"
              >Next
          </el-button>
          <div class="text_agreen_register">Already have ShopVidi account?<span class="login-now" @click="changeForm">Log in now</span></div>
        </el-form>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { postAction, getAction } from '@/api/manage.js'
import {loadSysRole} from '../../components/loadSysRole.js'
import { phoneRules } from '../../../components/validateRules.js'
export default {
  name: 'Home',
  data() {
    return {
      levelNames: ['low', 'low', 'Medium', 'Strong'],
      levelClass: [
        'el-icon-error',
        'el-icon-error',
        'el-icon-warning',
        'el-icon-success'
      ],
      levelColor: ['#ff0000', '#ff0000', '#ff7e05', '#52c41a'],
      levelStatus: 0,
      levelPercent: 10,
      emailLimit: '',
      onlyFlagEmail: false,
      passw: 'password',
      loading: false,
      codeObject: '+1(US)',
      newCountryCode: '',
      options: JSON.parse(localStorage.getItem('allCountry')) || [],
      countryNameCode: '',
      loginForm: {
        email: '',
        password: ''
      },
      registerForm: {
        email: '',
        password: '',
        code: '',
        phone: '',
        countryCode: '+1(US)',
        firstName: '',
        lastName: ''
      },
      onlyFlagPhone: false,
      rules: {
        phone: [{}]
      }
    }
  },
  watch: {
    'registerForm.countryCode'(newVal) {
      this.rules.phone = [
        { required: true, message: 'Please enter the correct number', trigger: 'blur'},
        { validator: phoneRules(this.registerForm.countryCode), trigger: ['change', 'blur']},
        { validator: this.checkOnlyPhone, trigger: 'change'}
      ]
    }
  },
  created() {
    this.rules.phone = [
      { required: true, message: 'Please enter the correct number', trigger: 'blur'},
      { validator: phoneRules(this.registerForm.countryCode), trigger: 'change'},
      { validator: this.checkOnlyPhone, trigger: 'change'}
    ]
    this.getPhoneAndCountry()
    this.loadConfigurationEmal()
    if (!this.isPartner) {
      this.registerForm.countryCode = '+86(CN)'
      this.codeObject = '+86(CN)'
      this.newCountryCode = 'CN'
    }
    gtag('event', 'conversion', {'send_to': 'AW-10872160881/iKr4CKfT66sDEPGEoMAo'})
    gtag('event', 'conversion', {'send_to': 'AW-301131205/cYGMCNH0ybIDEMXLy48B'})
    gtag('event', 'conversion', {'send_to': 'AW-342118137/59c2CI3FsuMCEPmdkaMB'})
    gtag('event', 'conversion', {'send_to': 'AW-10888618638/gDZdCJbUmLYDEI7FjMgo'})
  },
  methods: {
    changeForm() {
      this.$router.push({path: '/login'})
    },
    /**
     * 密码强度校验
     */
    handlePasswordLevel(rule, value, callback) {
      let level = 0
      let reg =
        /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/
      if (value === '') {
        callback(new Error('Please enter the Password'))
      }
      if (!reg.test(value)) {
        callback(
          new Error(
            'The password contains at least 8 characters, a combination of letters, numbers and special characters'
          )
        )
      }
      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++
      }
      this.levelStatus = level
      this.levelPercent = level * 30
      if (level >= 2) {
        if (level >= 3) {
          this.levelPercent = 100
        }
        callback()
      } else {
        if (level === 0) {
          this.levelPercent = 10
        }
        callback(new Error('The password strength is not enough'))
      }
    },
    /**
     * 变化type类型
     */
    showPass() {
      // 点击图标是密码隐藏或显示
      if (this.passw === 'text') {
        this.passw = 'password'
      } else {
        this.passw = 'text'
      }
    },
    /**
     * 手机号变化
     */
    changePhone(value) {
      this.registerForm.phone = value.replace(/[^\d]/g, '')
    },
    /**
     * 手机号国家变化
     */
    codeChange(code) {
      this.registerForm.countryCode = code.value
      this.codeObject = code.value
      if (code.desc) {
        let numberValue = code.desc.split(':')
        this.newCountryCode = numberValue[0]
      }
    },
    /**
     * 获取国家、手机号配置信息
     */
    getPhoneAndCountry() {
      getAction('/sys/dict/getDictItems/reg-country-config').then(response => {
        if (response.success) {
          if (response.result) {
            const tempOptions = []
            if (!this.isPartner) {
              tempOptions.push({
                'value': '+86(CN)',
                'text': 'China',
                'desc': 'CN:11',
                'title': 'China'
              })
            }
            tempOptions.push(...response.result)
            this.options = tempOptions
            localStorage.setItem('allCountry', JSON.stringify(response.result))
            console.log(JSON.parse(localStorage.getItem('allCountry')), '存到localStorage里的country')
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    /**
     * 检查邮件配置
     */
    loadConfigurationEmal() {
      getAction('/simple/configuration?key=sign_up_email_limit').then(response => {
        if (response.success) {
          if (response.result.configurationValue) {
            if (response.result.configurationValue !== '') {
              this.emailLimit = response.result.configurationValue
            }
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    /**
     * 检查手机号
     */
    // checkPhone(rule, value, callback) {
    //   let phone = this.registerForm.phone
    //   let code = this.registerForm.countryCode
    //   if (code === '') {
    //     callback(new Error('Please enter the countryCode'))
    //   }
    //   if (phone === '') {
    //     callback(new Error('Please enter the phone'))
    //   }
    //   // 如果是美国或者英国则判断后面手机号的长度
    //   if (code.indexOf('+1(US)') > -1 || code.indexOf('+44(UK)') > -1 || code.indexOf('+1(CA)') > -1) {
    //     if (phone.length !== 10) {
    //       callback(new Error('Please enter the correct number'))
    //     }
    //   }
    //   if (code.indexOf('+61(AU)') > -1) {
    //     if (phone.length !== 9) {
    //       callback(new Error('Please enter the correct number'))
    //     }
    //   }
    //   this.checkOnlyEmail(code + '-' + phone, 'phone')
    //   let that = this
    //   setTimeout(function () {
    //     if (that.onlyFlagPhone) {
    //       callback(new Error('This number has already been registered.'))
    //     } else {
    //       callback()
    //     }
    //   }, 300)
    // },
    checkOnlyPhone(rule, value, callback) {
      this.checkOnlyEmail(value, 'phone')
      let that = this
      setTimeout(function () {
        if (that.onlyFlagPhone) {
          callback(new Error('Phone registered'))
        } else {
          callback()
        }
      }, 500)
    },
    /**
     * 检查邮箱
     */
    checkEmail(rule, value, callback) {
      if (value) {
        value = value.trim()
      }
      var reg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      //  先判断格式是否正确，格式不正确则直接返回
      if (reg.test(value)) {
        //  判断我们是否有邮箱验证，
        if (this.emailLimit !== '') {
          let index = value.indexOf('@')
          if (index > -1) {
            const emailSuffix = value.substring(index, value.length)
            if (this.emailLimit.indexOf(emailSuffix) > -1) {
              callback(new Error('Please enter your email, if you cannot register, please contact customer service'))
              return
            }
            callback()
          }
          callback(new Error('Please enter the correct email address'))
          return
        }
        this.checkOnlyEmail(value, 'email')
        let that = this
        setTimeout(function () {
          if (that.onlyFlagEmail) {
            callback(new Error('This email has already been registered.'))
          } else {
            callback()
          }
        }, 300)
      } else {
        callback(new Error('Please enter the correct email address'))
      }
    },
    async checkOnlyEmail(value, type) {
      const params = {}
      if (type === 'email') {
        params.email = value
      } else {
        params.phone = this.registerForm.countryCode + '-' + value
      }
      let res = await getAction('/sys/user/checkOnlyUser', params)
      if (type === 'email') {
        // true ：表示存在
        this.onlyFlagEmail = !res.success
      } else {
        this.onlyFlagPhone = !res.success
      }
    },
    /**
     * 检查FirstName
     */
    userNameCheck(rule, value, callback) {
      if (this.registerForm.firstName === '') {
        callback(new Error('Please enter the firstName'))
      }
      callback()
    },
    /**
     * 检查LastName
     */
    userNameCheck2(rule, value, callback) {
      if (this.registerForm.lastName === '') {
        callback(new Error('Please enter the lastName'))
      }
      callback()
    },
    changeType(e) {
      e.srcElement.type = 'password'
    },
    /**
     * 返回
     */
    back() {
      this.loginForm = {}
      this.registerForm = {}
      this.$emit('backVisible')
    },
    /**
     * 提交验证
     */
    submitForm(type) {
      this.$refs[type].validate(async (valid) => {
        if (valid) {
          if (this.loading) {
            return
          }
          this.loading = true
          if (type === 'loginForm') {
            this.loginHandle()
          } else {
            this.registerHandle()
          }
        }
      })
    },
    // 注册接口
    registerHandle() {
      let values = this.registerForm
      if (values.countryCode === '') {
        this.$message.warning('Please enter country code!')
        return
      }
      var register = {
        phone: values.countryCode + '-' + values.phone,
        firstName: values.firstName,
        lastName: values.lastName,
        password: values.password,
        email: values.email,
        verifyCode: values.code,
        userSource: 3,
        model: 3,
        isVidirect: 1,
        supplierManagementModel: 1,
        countryCode: this.registerForm.countryCode === '+1(US)' ? 'US' : this.newCountryCode
      }
      // 默认值传参是 partner的 ，如果不是就更新
      if (!this.isPartner) {
        register.userSource = 2
        register.supplierManagementModel = 2
      }
      postAction('/sys/user/register', register).then((res) => {
        if (res.success) {
          this.loginForm = {
            ...register,
            ...{
              remember_me: true
            }
          }
          this.loginHandle()
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    loadSysRole() {
      loadSysRole(response => {
        const menuList = response
        let menu = menuList[0]
        if (menuList[0].childrenList && menuList[0].childrenList.length > 0) {
          menu = menuList[0].childrenList[0]
        }
        this.$router.push({path: 'menu/' + menu.key})
      })
    },
    /**
     * 登录
     */
    async loginHandle() {
      let username = this.loginForm.email.trim()
      let res = await postAction('/sys/login', {
        password: this.loginForm.password,
        remember_me: this.loginForm.remember,
        username: username,
        loginEntry: 2
      })
      if (res.code === 200) {
        this.$ls.set('token', res.result.token)
        this.$ls.set('userInfo', res.result.userInfo)
        this.$ls.set('realname', res.result.userInfo.realname)
        Vue.prototype.login = true
        Vue.prototype.username = res.result.userInfo.firstName + res.result.userInfo.lastName
        // 登录成功后 获取当前用户的business 审核状态
        if (this.login) {
          // 判断是不是partner，如果不是partner 订单列表
          if (!this.isPartner) {
            // 1、先暂时跳转到提交信息页面
            getAction('/register/supplier/replenish').then(response => {
              if (response.success) {
                if (response.result) {
                  // 如果是false的话就直接进入brand后台
                  if (!response.result.supplierStep) {
                    this.loadSysRole()
                  } else {
                    // 如果是true的话，看状态
                    const params = {}
                    if (response.result.supplierReviewStatus === 2) {
                      params.result = 'declined'
                    } else if (response.result.supplierReviewStatus === 1) {
                      params.result = 'approved'
                    } else if (response.result.supplierReviewStatus === 0) {
                      params.result = 'inReview'
                    } else {
                      params.result = 'profile'
                    }
                    this.$router.push({path: '/brand-review', query: params})
                  }
                }
              } else {
                this.$message.warning(response.message)
              }
            })
          } else {
            // 如果是partner在做判断
            // 获取用户信息
            let userInfo = JSON.parse(localStorage.getItem('pro__userInfo')).value
            if (userInfo) {
              getAction('/brand/api/v0.2/businesses/' + userInfo.id).then(response => {
                if (response.success) {
                  if (response.result.reviewStatus === 1) {
                    this.$router.push('/menu/procurement-orders')
                  } else {
                    this.$router.push('/review')
                  }
                }
              })
            }
          }
        }
      } else {
        this.$message.warning(res.message)
      }
      this.loading = false
    }
  }
}
</script>

<style scoped lang="less">
.text_agreen_register{
  padding: 10px 0px;
  width:100%;
  font-size: 13px;
  font-family: Graphik;
  font-weight: 400;
  text-align: center;
  .login-now{
    margin-left: 10px;
    text-decoration: underline;
    font-family: Satoshi-Bold !important;
    font-weight: 400 !important;
    cursor: pointer;
  }
}
.btn{
  margin-top: 5px;
}
.reg-show-hide-icon{
  width:20px;height:20px;
}
.login_moni{
  position: fixed;
  top: 20px;
  right: 20px;
  width: 100px;
  height: 40px;
  background: #FB541C;
  color: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  font-weight: bold;
  line-height: 40px;
  cursor: pointer;
}
/deep/.el-button--primary{
  width: 370px;
 height: 50px;
 background: #262B2F;
 border: none;
 border-radius: 0;
}
.text_agreen{
  width:100%;padding-left: 35px;margin-top:-28px;
  font-size: 14px;
  font-family: Graphik;
  font-weight: 400;
}
.organ_color{
  color: #FB541C;
  text-decoration:underline;
  cursor: pointer;
}
.home_box {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  box-sizing: border-box;
}
.login_box {
  width: 886px;
  height: 560px;
  background: rgba(255, 255, 255, 0.39);
  border: 1px solid #f0f0f0;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  .login_left,
  .login_right {
    flex: 1;
    /deep/ .el-form{
      width: 90%;
      margin:0 auto
    }
  }
  .login_right{
    margin:0 auto;
    text-align: center;
  }
  .login_left {
    background: #efd2b5;
    border-radius: 10px 0 0 10px;
    position: relative;
    .info {
      position: absolute;
      left: 20px;
      top: 20px;
      width: 400px;
      text-align: left;
      font-size: 20px;
      font-family: Graphik;
      font-weight: 500;
      line-height: 36px;
      color: #262b2f;
      word-break: keep-all;

      span {
        font-size: 24px;
      }
    }
    .login_img {
      width: 380px;
      height: 315px;
      margin: 64px 0 0 25px;
    }
    .icon_line_box{
      margin-top: 17px;
    }
    .icon_line{
      margin: 0 0 2px 12px;
      align-items: center;
        .icon_img{
          width: 28px;
          height: 28px;
        }
        p{
          margin-left: 6px;
          line-height: 26px;
          font-size: 12px;
        }
      }

  }
  .shopvidi_logo{
    width: 175px;
    height: 45px;
    margin: 40px 0px 20px 0px ;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/register/register.vue